import { gql } from '@apollo/client';

export const GLOBAL_SEARCH = gql`
query GlobalSearch($customsTerritories: [String!]!, $searchTerm: String!, $limit: Int = 10) {
  search(customsTerritories: $customsTerritories, filter: {searchTerm: $searchTerm}) {
    consignments(limit: $limit) {
      items {
        id
        billOfLadingNbr
        carrier
      }
      pageInfo {
        totalCount
      }
    }
    equipmentVehicles(limit: $limit) {
      items {
        carrier
        id
        modeOfTransport
        voyageNumber
        originCountry
        dischargeCountry
      }
      pageInfo {
        totalCount
      }
    }
    exceptions(limit: $limit) {
      items {
        alias
        id
        description
        status
        consignment {
          id
          billOfLadingNbr
        }
      }
      pageInfo {
        totalCount
      }
    }
  }
}`;

export const GLOBAL_SEARCH_CONSIGNMENTS = gql`
query GlobalSearch($customsTerritories: [String!]!, $searchTerm: String!, $offset: Int = 0, $limit: Int = 10) {
  search(customsTerritories: $customsTerritories, filter: {searchTerm: $searchTerm}) {
    consignments(offset: $offset, limit: $limit) {
      items {
        id
        billOfLadingNbr
        carrier
      }
      pageInfo {
        totalCount
      }
    }
  }
}`;

export const GLOBAL_SEARCH_VEHICLES = gql`
query GlobalSearch($customsTerritories: [String!]!, $searchTerm: String!, $offset: Int = 0, $limit: Int = 10) {
  search(customsTerritories: $customsTerritories, filter: {searchTerm: $searchTerm}) {
    equipmentVehicles(offset: $offset, limit: $limit) {
      items {
        carrier
        id
        modeOfTransport
        voyageNumber
        originCountry
        dischargeCountry
      }
      pageInfo {
        totalCount
      }
    }
  }
}`;

export const GLOBAL_SEARCH_EXCEPTIONS = gql`
query GlobalSearch($customsTerritories: [String!]!, $searchTerm: String!, $offset: Int = 0, $limit: Int = 10) {
  search(customsTerritories: $customsTerritories, filter: {searchTerm: $searchTerm}) {
    exceptions(offset: $offset, limit: $limit) {
      items {
        alias
        id
        description
        status
        consignment {
          id
          billOfLadingNbr
        }
      }
      pageInfo {
        totalCount
      }
    }
  }
}`;
